// import React, { useEffect, useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { ArrowLeft, ChevronDown, ChevronUp } from 'lucide-react';
// import { certGetReportTypes } from '../../services/reportingHubApi';

// const CertificationHome = () => {
//   const navigate = useNavigate();
//   const [reportTypes, setReportTypes] = useState([]);
//   const [selected, setSelected] = useState('');
//   const [isFocused, setIsFocused] = useState(false);
//   const [isOpen, setIsOpen] = useState(false);

//   useEffect(() => {
//     certGetReportTypes()
//       .then((d) => setReportTypes(d.reportTypes || []))
//       .catch(() => setReportTypes([]));
//   }, []);

//   const proceed = (key) => {
//     if (key) navigate(`/reporting-hub/certification/search?type=${key}`);
//   };

//   return (
//     <div className="min-h-screen bg-black text-white px-3 py-4 sm:px-4 sm:py-5 md:px-6 md:py-6 lg:px-8">
//       <div className="w-full mx-auto">
//         <div className="flex items-center gap-2 sm:gap-3 pb-3 sm:pb-4 border-b border-gray-400 mb-5 sm:mb-10 sm:-ml-4 -ml-2">
//           <button
//             onClick={() => navigate('/project-reporting')}
//             className="p-1 sm:p-2 rounded-full hover:bg-gray-800 transition-colors flex-shrink-0"
//             aria-label="Go back"
//           >
//             <ArrowLeft className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" />
//           </button>

//           <h1 className="text-sm sm:text-lg md:text-2xl lg:text-2xl xl:text-2xl font-bold leading-tight break-words">
//             Project Reporting Hub_Certification
//           </h1>
//         </div>


//         <label className="block text-xs sm:text-lg md:text-lg font-semibold mb-2">
//           Step 1 : Select report type
//         </label>

//         <div className="relative w-full">
//           <select
//             value={selected}
//             onClick={() => setIsOpen((prev) => !prev)}
//             onBlur={() => setIsOpen(false)}
//             onChange={(e) => {
//               setSelected(e.target.value);
//               setIsOpen(false);
//               proceed(e.target.value);
//             }}
//             className="
//       w-full
//       bg-gray-900
//       border border-gray-700
//       rounded-lg
//       px-3 sm:px-4
//       py-2.5 sm:py-4
//       pr-10
//       text-xs sm:text-base md:text-base
//       text-white
//       outline-none
//       focus:ring-2
//       focus:ring-blue-500
//       appearance-none
//       cursor-pointer
//     "
//           >
//             <option value="">-- Select report type --</option>

//             {reportTypes.map((rt) => (
//               <option key={rt.key} value={rt.key}>
//                 {rt.label}
//               </option>
//             ))}
//           </select>
//           <div
//             className="
//     absolute
//     right-2 sm:right-3 md:right-4
//     top-1/2
//     -translate-y-1/2
//     pointer-events-none
//   "
//           >
//             {isOpen ? (
//               <ChevronUp
//                 className="
//         w-5 h-5
//         sm:w-5 sm:h-5
//         md:w-5 md:h-5
//         lg:w-6 lg:h-6
//         text-white
//       "
//               />
//             ) : (
//               <ChevronDown
//                 className="
//         w-5 h-5
//         sm:w-5 sm:h-5
//         md:w-5 md:h-5
//         lg:w-6 lg:h-6
//         text-white
//       "
//               />
//             )}
//           </div>
//         </div>

//         {!selected && (
//           <div className="mt-12 flex justify-center sm:pt-40  pt-25">
//             <div className="max-w-2xl text-center border border-gray-700 rounded-xl bg-gray-900/50 px-6 py-8">

//               <p className="text-sm sm:text-base text-gray-300 ">
//                 Select a report type from the dropdown above to continue.
//                 Once selected, you will be redirected to the corresponding
//                 report search page.w
//               </p>


//             </div>
//           </div>
//         )}

//       </div>
//     </div>

//   );
// };

// export default CertificationHome;



import React, { useState, useRef, useEffect } from "react";
import { getCertandSW } from "../../services/apiService";
import { certGetReportTypes } from '../../services/reportingHubApi';
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft, ChevronDown } from "lucide-react";

const ProjectReportingCertificationHub = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [reportTypes, setReportTypes] = useState([]);
  const [reportTypeKey, setReportTypeKey] = useState("");
  const [reportTypeLabel, setReportTypeLabel] = useState("");
  const reportRef = useRef();
  const yearRef = useRef();
  const projectRef = useRef();
  const [reportType, setReportType] = useState("");
  const [year, setYear] = useState("");
  const [project, setProject] = useState("");
  const [years, setYears] = useState([]);
  const [projects, setProjects] = useState([]);
  const [allProjects, setAllProjects] = useState([]);
  const [selectedProjectData, setSelectedProjectData] = useState(null);
  const [openDropdown, setOpenDropdown] = useState("");

  useEffect(() => {
      loadReportTypes();
  }, []);

  const loadReportTypes = async () => {
      try {
          const response = await certGetReportTypes();

          setReportTypes(response.reportTypes || []);
      } catch (err) {
          console.error(err);
          setReportTypes([]);
      }
  };

    useEffect(() => {
        loadCertAndSWData("Cert and SW Project Template");
    }, []);

  const loadCertAndSWData = async (reportType) => {
    try {
        const response = await getCertandSW(
        "Cert and SW Project Template"
    );

        if (response.success) {
            const projectData =
                (response.data?.projects ||
                    response.projects ||
                    []).map(item => {

                    const match = item.project.match(/^#(\d+),(.*)$/);

                    return {
                        year: item.year.toUpperCase(),
                        projectId: match ? Number(match[1]) : null,
                        project: item.project,
                        projectName: match
                            ? match[2].trim()
                            : item.project
                    };
                });

            setAllProjects(projectData);
            const uniqueYears = [
                ...new Set(
                    projectData.map(p => p.year.toUpperCase())
                )
            ];
            setYears(uniqueYears);
        }
    } catch (err) {
        console.error(err);
    }
};
 



useEffect(() => {
  if (!location.state || !allProjects.length) return;

  const {
    reportTypeKey,
    reportTypeLabel,
    year,
    selectedProject,
  } = location.state;

  // Restore report type
  if (reportTypeLabel) {
    setReportType(reportTypeLabel);
    setReportTypeKey(reportTypeKey);
    setReportTypeLabel(reportTypeLabel);
  }

  // Restore year
  if (year) {
    setYear(year);
  }

  if (!selectedProject || !year) return;

  const filteredProjects = allProjects.filter(
    p => p.year.toUpperCase() === year.toUpperCase()
  );

  setProjects(filteredProjects);

  const selected = filteredProjects.find(
    p =>
      String(p.projectId) === String(selectedProject.projectId) &&
      p.project === selectedProject.project
  );

  if (selected) {
    setSelectedProjectData(selected);
    setProject(selected.project);
  } else {
    // Fallback
    setSelectedProjectData(selectedProject);
    setProject(selectedProject.project);
  }
}, [allProjects, location.state]);


  useEffect(() => {
    const closeDropdown = (e) => {
      if (
        reportRef.current &&
        !reportRef.current.contains(e.target) &&
        yearRef.current &&
        !yearRef.current.contains(e.target) &&
        projectRef.current &&
        !projectRef.current.contains(e.target)
      ) {
        setOpenDropdown("");
      }
    };
    document.addEventListener("mousedown", closeDropdown);
    return () =>
      document.removeEventListener("mousedown", closeDropdown);
  }, []);

    const renderDropdown = (
      value,
      setValue,
      options,
      type
    ) => {
      const currentRef =
        type === "report"
          ? reportRef
          : type === "year"
          ? yearRef
          : projectRef;

  return (
    <div className="relative w-full" ref={currentRef}>
      <button
        type="button"
        onClick={() =>
          setOpenDropdown(openDropdown === type ? "" : type)
        }
        className="w-full h-12 rounded-lg bg-[#1B2940] border border-[#263C57] px-4 flex items-center justify-between text-white"
      >
        <span className="truncate text-sm">
          {type === "project"
            ? selectedProjectData?.project || "Select"
            : value || "Select"}
        </span>

        <ChevronDown
          size={20}
          className={`transition ${
            openDropdown === type ? "rotate-180" : ""
          }`}
        />
      </button>

      {openDropdown === type && (
        <div className="absolute left-0 top-14 w-full bg-[#1E2B40] border border-[#2C4566] rounded-md shadow-xl z-50 max-h-64 overflow-y-auto">
          {options.map((item) => {
            if (type === "year") {
              return (
                <div
                key={item}
                onClick={() => {
                  setValue(item);
                  setOpenDropdown("");
                }}
                className={`flex items-center gap-3 px-4 py-2 cursor-pointer text-sm ${
                  value === item
                    ? "bg-gray-600 text-white"
                    : "text-white hover:bg-[#2B4366]"
                }`}
              >
                <span className="w-1.5 h-1.5 rounded-full bg-white flex-shrink-0"></span>
                <span>{item}</span>
                </div>
              );
            }

              if (type === "report") {
                  return (
                     <div
                    key={item.key}
                    onClick={() => {
                      setReportType(item.label);
                      setReportTypeKey(item.key);
                      setReportTypeLabel(item.label);
                      setOpenDropdown("");
                    }}
                    className={`flex items-center gap-3 px-4 py-2 cursor-pointer text-sm ${
                      reportType === item.label
                        ? "bg-gray-600 text-white"
                        : "text-white hover:bg-[#2B4366]"
                    }`}
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-white flex-shrink-0"></span>
                    <span>{item.label}</span>
                  </div>
                  );
              }

            return (
            
              <div
              key={item.projectId}
              onClick={() => {
                setProject(item.project);
                setSelectedProjectData(item);
                setOpenDropdown("");
              }}
              className={`flex items-center gap-3 px-4 py-2 cursor-pointer text-sm ${
                selectedProjectData?.projectId === item.projectId
                  ? "bg-gray-600 text-white"
                  : "text-white hover:bg-[#2B4366]"
              }`}
            >
              <span className="w-1.5 h-1.5 rounded-full bg-white flex-shrink-0"></span>
              <span className="whitespace-nowrap">{item.project}</span>
            </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

useEffect(() => {
  if (!year) {
    setProjects([]);
    return;
  }

  const filtered = allProjects.filter(
    item => item.year.toUpperCase() === year.toUpperCase()
  );

  setProjects(filtered);

}, [year, allProjects]);

const handleNext = () => {

    if (!reportType) {
        alert("Please select Report Type");
        return;
    }

    if (!year) {
        alert("Please select Year");
        return;
    }

    if (!selectedProjectData) {
        alert("Please select Project");
        return;
    }

navigate(
    "/reporting-hub/certification/view",
    {
        state: {
            reportTypeKey,
            reportTypeLabel,
            year,
            projectId: selectedProjectData.projectId,
            project: selectedProjectData.project,
            selectedProject: selectedProjectData
        }
    }
);

};

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Header */}

      <div className="flex items-center gap-4 px-4 lg:px-8 py-5">
        {/* <ArrowLeft className="cursor-pointer" size={30} /> */}
                  <button
            onClick={() => navigate('/project-reporting')}
            className="p-1 sm:p-2 rounded-full hover:bg-gray-800 transition-colors flex-shrink-0"
            aria-label="Go back"
          >
            <ArrowLeft className="w-6 h-6 sm:w-7 sm:h-7 md:w-6 md:h-6 font-bold" />
          </button>

        <h1 className="text-lg sm:text-xl md:text-2xl lg:text-3xl xl:text-4xl font-bold leading-tight break-words">
          Project Reporting Hub_Certification
        </h1>
      </div>

      <div className="border-b border-gray-600"></div>
      <div className="px-4 lg:px-8 py-8">

        {/* Step 1 */}

        <h2 className="text-xl sm:mb-6 mb-2">
          Step 1 : Select report type
        </h2>
       <div className="w-full md:w-96">
        {renderDropdown(
          reportType,
          setReportType,
          reportTypes,
          "report"
        )}
      </div>

        {/* Step 2 */}

        <div className="sm:mt-24 mt-10">
          <h2 className="text-xl sm:mb-8 mb-4">
            Step 2 : Set filters
          </h2>

          <h3 className="text-2xl font-bold">
            Filters
          </h3>

          <div className="border-b border-gray-600 mt-3 sm:mb-12 mb-6"></div>
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">

            {/* Year */}
            <div className="flex items-center gap-4">
              <label className=" sm:text-xl text:sm font-medium text-white whitespace-nowrap">
                Year
              </label>

              <div ref={yearRef} className="flex-1">
                {renderDropdown(
                  year,
                  setYear,
                  years,
                  "year"
                )}
              </div>
            </div>

            {/* Project */}

            <div className="flex items-center gap-4">
          <label className="sm:text-xl text:sm font-medium text-white whitespace-nowrap">
            Project
          </label>

          <div ref={projectRef} className="flex-1">
            {renderDropdown(
              project,
              setProject,
              projects,
              "project"
            )}
          </div>
        </div>
          </div>

          <div className="flex justify-center sm:mt-40 mt-10">
            <button
              onClick={handleNext}
              disabled={
                  !reportTypeKey ||
                  !year ||
                  !selectedProjectData
              }
              className={`px-16 py-3 rounded-lg text-base font-medium transition ${
                  !reportTypeKey || !year || !selectedProjectData
                      ? "bg-gray-600 cursor-not-allowed text-gray-300"
                      : "bg-blue-600 hover:bg-blue-700 text-white"
              }`}
          >
              Done and Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectReportingCertificationHub;